
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page",
      function () {
        return require("private-next-pages/page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page"])
      });
    }
  